<div class="flex flex-col h-full">
  <div>
    <h1>Risikoopkrævninger</h1>
  </div>
  <p-tabs
    [(value)]="opkraevningService.activeTab"
    class="flex-1 border-1 overflow-hidden">
    <p-tablist>
      <p-tab value="search"><i class="pi pi-search"></i> Søgning</p-tab>
      <p-tab value="result"><i class="pi pi-list"></i> Resultat </p-tab>
      @if (opkraevningService.selectedOpkraevning()) {
        <p-tab value="detail"><i class="pi pi-file"></i> Detaljer</p-tab>
      }
    </p-tablist>
    <p-tabpanels class="overflow-hidden">
      <p-tabpanel value="search">
        <app-opkraevning-search />
      </p-tabpanel>
      <p-tabpanel value="result">
        <app-opkraevning-result />
      </p-tabpanel>
      <p-tabpanel value="detail">
        @let opkraevning = opkraevningService.selectedOpkraevning();
        @if (opkraevning) {
          <app-risiko-opkraevning-detail [risikoOpkraevning]="opkraevning" />
        }
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
